export default __webpack_public_path__ + "static/media/check-circle-green.197b1a8d.svg";